import React, { useState ,useRef} from "react";
import { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "./Swipper.css";
import { Navigation } from "swiper/modules";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const SubSubCategory5 = ({ data }) => {
  // Dummy data for categories with placeholder images

  const [backgroundColor, setBackgroundColor] = useState("");
  const [titleColor, setTitleColor] = useState("");
  const [titleFont, setTitleFont] = useState("");
  const [title, setTitle] = useState("");
  const [titleAlignment, setTitleAlignment] = useState("");
  const [cornerRadius, setCornerRadius] = useState("");
  const [itemMargin, setItemMargin] = useState("");
  const [itemPadding, setItemPadding] = useState("");
  const [labelPosition, setLabelPosition] = useState("");
  const [noOfColumn, setNoOfColumn] = useState("");
  const [webHeight, setWebHeight] = useState("");
  const [textAlignment, setTextAlignment] = useState("");

  const component = data;
  const categories = data["get_home_component_details"]["content"];
  const swiperRef_sc_5=useRef(null)

  useEffect(() => {
    setBackgroundColor(component.web_background_color);
    setTitleColor(component.web_title_color);
    setTitleFont(component.web_title_font);
    setTitle(component.title);
    setTitleAlignment(component.title_alignment);
    setCornerRadius(component.corner_radius);
    setItemMargin(component.item_margin);
    setItemPadding(component.item_padding);
    setLabelPosition(component.label_position);
    setNoOfColumn(component.no_of_column);
    setTextAlignment(component.text_alignment);
     setWebHeight(component.web_height);
  }, []);



  const truncateNameMobile = (name) => {
    return name.length > 6 ? name.substring(0, 6) + "..." : name;
  };

  const truncateNameDesktop = (name) => {
    return name.length > 15 ? name.substring(0, 15) + "..." : name;
  };


  return (
    <div className="px-2 py-3" style={{ backgroundColor: backgroundColor }}>
      {" "}
      {/* Padding on both sides */}
      {/* Desktop View: 6 Cards per Row, No Gap, Fully Rounded */}
      <div
        className={`text-2xl font-bold ${
          titleAlignment === "center"
            ? "text-center"
            : titleAlignment === "start"
            ? "text-left"
            : "text-center"
        }`}
        style={{
          color: titleColor,
          fontFamily: titleFont,
        }}
      >
        {title}
      </div>
      {noOfColumn === "2" &&
        ["top", "center", "bottom"].includes(labelPosition) && (
          <div className="justify-center hidden w-full grid-cols-2 gap-1 overflow-hidden lg:grid">
            {categories.slice(0, 8).map((category) => (
              <div
                key={category.subcategory_auto_id}
                className="flex justify-center w-full"
              >
                <div
                  className="flex items-center w-full p-2 text-center"
                  style={{
                    margin: `${parseInt(itemMargin, 10)}px`,
                    padding: `${parseInt(itemPadding, 10)}px`,
                  }}
                >
                  <Link
                     to="/subsubcatproductlist"
                    state={{
                      subsubcategoryName: category.sub_category_name,
                      sub_sub_cat_id: category.sub_sub_category_auto_id,
                    }}
                    className="flex flex-col items-center w-full text-decoration-none"
                  >
                    {/* Text at the Top */}
                    {labelPosition === "top" && textAlignment === "beside" && (
                      <p className="mb-2 text-sm text-black">
                        {truncateNameDesktop(category.sub_category_name)}
                      </p>
                    )}

                    {/* Fully Rounded Image */}
                    <div className="relative w-full">
                      {textAlignment === "over" && labelPosition === "top" && (
                        <p
                          className="absolute top-0 left-0 right-0 h-10 p-2 text-sm text-center text-white bg-black bg-opacity-50"
                          style={{
                            borderTopLeftRadius: `${parseInt(
                              cornerRadius,
                              10
                            )}px`,
                            borderTopRightRadius: `${parseInt(
                              cornerRadius,
                              10
                            )}px`,
                          }}
                        >
                          {truncateNameDesktop(category.sub_category_name)}
                        </p>
                      )}
                      <img
                        src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/subcategories/${category.subcategory_image_app}`}
                        alt={category.sub_category_name}
                        className={`object-cover w-full `}
                        style={{
                          height: `${webHeight}px`,
                          borderRadius: `${parseInt(cornerRadius, 10)}px`,
                        }}
                      />
                      {/* Text Overlay for Center */}
                      {textAlignment === "over" &&
                        labelPosition === "center" && (
                          <p
                            className={`absolute inset-0 flex items-center justify-center text-sm text-white bg-black bg-opacity-50 p-2 `}
                            style={{
                              height: `${webHeight}px`,
                              borderRadius: `${parseInt(cornerRadius, 10)}px`,
                            }}
                          >
                            {truncateNameDesktop(category.sub_category_name)}
                          </p>
                        )}

                      {/* Text Overlay at the Bottom */}
                      {textAlignment === "over" &&
                        labelPosition === "bottom" && (
                          <p
                            className="absolute bottom-0 left-0 right-0 h-10 p-2 mb-0 text-sm text-center text-white bg-black bg-opacity-50"
                            style={{
                              borderBottomLeftRadius: `${parseInt(
                                cornerRadius,
                                10
                              )}px`,
                              borderBottomRightRadius: `${parseInt(
                                cornerRadius,
                                10
                              )}px`,
                            }}
                          >
                            {truncateNameDesktop(category.sub_category_name)}
                          </p>
                        )}
                    </div>

                    {/* Text at the Bottom */}
                    {((labelPosition === "bottom" &&
                      textAlignment === "beside") ||
                      (labelPosition === "center" &&
                        textAlignment === "beside")) && (
                      <p className="mt-2 text-sm text-black">
                        {truncateNameDesktop(category.sub_category_name)}
                      </p>
                    )}
                  </Link>
                </div>
              </div>
            ))}
          </div>
        )}
      {noOfColumn === "3" &&
        ["top", "center", "bottom"].includes(labelPosition) && (
          <div className="justify-center hidden w-full grid-cols-3 gap-1 overflow-hidden lg:grid">
            {categories.slice(0, 8).map((category) => (
              <div
                key={category.subcategory_auto_id}
                className="flex justify-center w-full"
              >
                <div
                  className="flex items-center w-full p-2 text-center"
                  style={{
                    margin: `${parseInt(itemMargin, 10)}px`,
                    padding: `${parseInt(itemPadding, 10)}px`,
                  }}
                >
                  <Link
                       to="/subsubcatproductlist"
                       state={{
                         subsubcategoryName: category.sub_category_name,
                         sub_sub_cat_id: category.sub_sub_category_auto_id,
                       }}
                    className="flex flex-col items-center w-full text-decoration-none"
                  >
                    {/* Text at the Top */}
                    {labelPosition === "top" && textAlignment === "beside" && (
                      <p className="mb-2 text-sm text-black">
                        {truncateNameDesktop(category.sub_category_name)}
                      </p>
                    )}

                    {/* Fully Rounded Image */}
                    <div className="relative w-full">
                      {textAlignment === "over" && labelPosition === "top" && (
                        <p
                          className="absolute top-0 left-0 right-0 h-10 p-2 text-sm text-center text-white bg-black bg-opacity-50"
                          style={{
                            borderTopLeftRadius: `${parseInt(
                              cornerRadius,
                              10
                            )}px`,
                            borderTopRightRadius: `${parseInt(
                              cornerRadius,
                              10
                            )}px`,
                          }}
                        >
                          {truncateNameDesktop(category.sub_category_name)}
                        </p>
                      )}
                      <img
                        src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/subcategories/${category.subcategory_image_app}`}
                        alt={category.sub_category_name}
                        className={`object-cover w-full `}
                        style={{
                          height: `${webHeight}px`,
                          borderRadius: `${parseInt(cornerRadius, 10)}px`,
                        }}
                      />
                      {/* Text Overlay for Center */}
                      {textAlignment === "over" &&
                        labelPosition === "center" && (
                          <p
                            className={`absolute inset-0 flex items-center justify-center text-sm text-white bg-black bg-opacity-50 p-2 `}
                            style={{
                              height: `${webHeight}px`,
                              borderRadius: `${parseInt(cornerRadius, 10)}px`,
                            }}
                          >
                            {truncateNameDesktop(category.sub_category_name)}
                          </p>
                        )}

                      {/* Text Overlay at the Bottom */}
                      {textAlignment === "over" &&
                        labelPosition === "bottom" && (
                          <p
                            className="absolute bottom-0 left-0 right-0 h-10 p-2 mb-0 text-sm text-center text-white bg-black bg-opacity-50"
                            style={{
                              borderBottomLeftRadius: `${parseInt(
                                cornerRadius,
                                10
                              )}px`,
                              borderBottomRightRadius: `${parseInt(
                                cornerRadius,
                                10
                              )}px`,
                            }}
                          >
                            {truncateNameDesktop(category.sub_category_name)}
                          </p>
                        )}
                    </div>

                    {/* Text at the Bottom */}
                    {((labelPosition === "bottom" &&
                      textAlignment === "beside") ||
                      (labelPosition === "center" &&
                        textAlignment === "beside")) && (
                      <p className="mt-2 text-sm text-black">
                        {truncateNameDesktop(category.sub_category_name)}
                      </p>
                    )}
                  </Link>
                </div>
              </div>
            ))}
          </div>
        )}
      {noOfColumn === "4" &&
        ["top", "center", "bottom"].includes(labelPosition) && (
          <div className="justify-center hidden w-full grid-cols-4 gap-1 overflow-hidden lg:grid">
            {categories.slice(0, 8).map((category) => (
              <div
                key={category.subcategory_auto_id}
                className="flex justify-center w-full"
              >
                <div
                  className="flex items-center w-full p-2 text-center"
                  style={{
                    margin: `${parseInt(itemMargin, 10)}px`,
                    padding: `${parseInt(itemPadding, 10)}px`,
                  }}
                >
                  <Link
                    to="/subsubcatproductlist"
                    state={{
                      subsubcategoryName: category.sub_category_name,
                      sub_sub_cat_id: category.sub_sub_category_auto_id,
                    }}
                    className="flex flex-col items-center w-full text-decoration-none"
                  >
                    {/* Text at the Top */}
                    {labelPosition === "top" && textAlignment === "beside" && (
                      <p className="mb-2 text-sm text-black">
                        {truncateNameDesktop(category.sub_category_name)}
                      </p>
                    )}

                    {/* Fully Rounded Image */}
                    <div className="relative w-full">
                      {textAlignment === "over" && labelPosition === "top" && (
                        <p
                          className="absolute top-0 left-0 right-0 h-10 p-2 text-sm text-center text-white bg-black bg-opacity-50"
                          style={{
                            borderTopLeftRadius: `${parseInt(
                              cornerRadius,
                              10
                            )}px`,
                            borderTopRightRadius: `${parseInt(
                              cornerRadius,
                              10
                            )}px`,
                          }}
                        >
                          {truncateNameDesktop(category.sub_category_name)}
                        </p>
                      )}
                      <img
                        src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/subcategories/${category.subcategory_image_app}`}
                        alt={category.sub_category_name}
                        className={`object-cover w-full `}
                        style={{
                          height: `${webHeight}px`,
                          borderRadius: `${parseInt(cornerRadius, 10)}px`,
                        }}
                      />
                      {/* Text Overlay for Center */}
                      {textAlignment === "over" &&
                        labelPosition === "center" && (
                          <p
                            className={`absolute inset-0 flex items-center justify-center text-sm text-white bg-black bg-opacity-50 p-2 `}
                            style={{
                              height: `${webHeight}px`,
                              borderRadius: `${parseInt(cornerRadius, 10)}px`,
                            }}
                          >
                            {truncateNameDesktop(category.sub_category_name)}
                          </p>
                        )}

                      {/* Text Overlay at the Bottom */}
                      {textAlignment === "over" &&
                        labelPosition === "bottom" && (
                          <p
                            className="absolute bottom-0 left-0 right-0 h-10 p-2 mb-0 text-sm text-center text-white bg-black bg-opacity-50"
                            style={{
                              borderBottomLeftRadius: `${parseInt(
                                cornerRadius,
                                10
                              )}px`,
                              borderBottomRightRadius: `${parseInt(
                                cornerRadius,
                                10
                              )}px`,
                            }}
                          >
                            {truncateNameDesktop(category.sub_category_name)}
                          </p>
                        )}
                    </div>

                    {/* Text at the Bottom */}
                    {((labelPosition === "bottom" &&
                      textAlignment === "beside") ||
                      (labelPosition === "center" &&
                        textAlignment === "beside")) && (
                      <p className="mt-2 text-sm text-black">
                        {truncateNameDesktop(category.sub_category_name)}
                      </p>
                    )}
                  </Link>
                </div>
              </div>
            ))}
          </div>
        )}
      {noOfColumn === "5" &&
        ["top", "center", "bottom"].includes(labelPosition) && (
          <div className="justify-center hidden w-full grid-cols-5 gap-1 overflow-hidden lg:grid">
            {categories.slice(0, 8).map((category) => (
              <div
                key={category.subcategory_auto_id}
                className="flex justify-center w-full"
              >
                <div
                  className="flex items-center w-full p-2 text-center"
                  style={{
                    margin: `${parseInt(itemMargin, 10)}px`,
                    padding: `${parseInt(itemPadding, 10)}px`,
                  }}
                >
                  <Link
                       to="/subsubcatproductlist"
                       state={{
                         subsubcategoryName: category.sub_category_name,
                         sub_sub_cat_id: category.sub_sub_category_auto_id,
                       }}
                    className="flex flex-col items-center w-full text-decoration-none"
                  >
                    {/* Text at the Top */}
                    {labelPosition === "top" && textAlignment === "beside" && (
                      <p className="mb-2 text-sm text-black">
                        {truncateNameDesktop(category.sub_category_name)}
                      </p>
                    )}

                    {/* Fully Rounded Image */}
                    <div className="relative w-full">
                      {textAlignment === "over" && labelPosition === "top" && (
                        <p
                          className="absolute top-0 left-0 right-0 h-10 p-2 text-sm text-center text-white bg-black bg-opacity-50"
                          style={{
                            borderTopLeftRadius: `${parseInt(
                              cornerRadius,
                              10
                            )}px`,
                            borderTopRightRadius: `${parseInt(
                              cornerRadius,
                              10
                            )}px`,
                          }}
                        >
                          {truncateNameDesktop(category.sub_category_name)}
                        </p>
                      )}
                      <img
                        src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/subcategories/${category.subcategory_image_app}`}
                        alt={category.sub_category_name}
                        className={`object-cover w-full `}
                        style={{
                          height: `${webHeight}px`,
                          borderRadius: `${parseInt(cornerRadius, 10)}px`,
                        }}
                      />
                      {/* Text Overlay for Center */}
                      {textAlignment === "over" &&
                        labelPosition === "center" && (
                          <p
                            className={`absolute inset-0 flex items-center justify-center text-sm text-white bg-black bg-opacity-50 p-2 `}
                            style={{
                              height: `${webHeight}px`,
                              borderRadius: `${parseInt(cornerRadius, 10)}px`,
                            }}
                          >
                            {truncateNameDesktop(category.sub_category_name)}
                          </p>
                        )}

                      {/* Text Overlay at the Bottom */}
                      {textAlignment === "over" &&
                        labelPosition === "bottom" && (
                          <p
                            className="absolute bottom-0 left-0 right-0 h-10 p-2 mb-0 text-sm text-center text-white bg-black bg-opacity-50"
                            style={{
                              borderBottomLeftRadius: `${parseInt(
                                cornerRadius,
                                10
                              )}px`,
                              borderBottomRightRadius: `${parseInt(
                                cornerRadius,
                                10
                              )}px`,
                            }}
                          >
                            {truncateNameDesktop(category.sub_category_name)}
                          </p>
                        )}
                    </div>

                    {/* Text at the Bottom */}
                    {((labelPosition === "bottom" &&
                      textAlignment === "beside") ||
                      (labelPosition === "center" &&
                        textAlignment === "beside")) && (
                      <p className="mt-2 text-sm text-black">
                        {truncateNameDesktop(category.sub_category_name)}
                      </p>
                    )}
                  </Link>
                </div>
              </div>
            ))}
          </div>
        )}
      {noOfColumn === "6" &&
        ["top", "center", "bottom"].includes(labelPosition) && (
          <div className="justify-center hidden w-full grid-cols-6 gap-1 overflow-hidden lg:grid">
            {categories.slice(0, 8).map((category) => (
              <div
                key={category.subcategory_auto_id}
                className="flex justify-center w-full"
              >
                <div
                  className="flex items-center w-full p-2 text-center"
                  style={{
                    margin: `${parseInt(itemMargin, 10)}px`,
                    padding: `${parseInt(itemPadding, 10)}px`,
                  }}
                >
                  <Link
                    to="/subsubcatproductlist"
                    state={{
                      subsubcategoryName: category.sub_category_name,
                      sub_sub_cat_id: category.sub_sub_category_auto_id,
                    }}
                    className="flex flex-col items-center w-full text-decoration-none"
                  >
                    {/* Text at the Top */}
                    {labelPosition === "top" && textAlignment === "beside" && (
                      <p className="mb-2 text-sm text-black">
                        {truncateNameDesktop(category.sub_category_name)}
                      </p>
                    )}

                    {/* Fully Rounded Image */}
                    <div className="relative w-full">
                      {textAlignment === "over" && labelPosition === "top" && (
                        <p
                          className="absolute top-0 left-0 right-0 h-10 p-2 text-sm text-center text-white bg-black bg-opacity-50"
                          style={{
                            borderTopLeftRadius: `${parseInt(
                              cornerRadius,
                              10
                            )}px`,
                            borderTopRightRadius: `${parseInt(
                              cornerRadius,
                              10
                            )}px`,
                          }}
                        >
                          {truncateNameDesktop(category.sub_category_name)}
                        </p>
                      )}
                      <img
                        src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/subcategories/${category.subcategory_image_app}`}
                        alt={category.sub_category_name}
                        className={`object-cover w-full `}
                        style={{
                          height: `${webHeight}px`,
                          borderRadius: `${parseInt(cornerRadius, 10)}px`,
                        }}
                      />
                      {/* Text Overlay for Center */}
                      {textAlignment === "over" &&
                        labelPosition === "center" && (
                          <p
                            className={`absolute inset-0 flex items-center justify-center text-sm text-white bg-black bg-opacity-50 p-2 `}
                            style={{
                              height: `${webHeight}px`,
                              borderRadius: `${parseInt(cornerRadius, 10)}px`,
                            }}
                          >
                            {truncateNameDesktop(category.sub_category_name)}
                          </p>
                        )}

                      {/* Text Overlay at the Bottom */}
                      {textAlignment === "over" &&
                        labelPosition === "bottom" && (
                          <p
                            className="absolute bottom-0 left-0 right-0 h-10 p-2 mb-0 text-sm text-center text-white bg-black bg-opacity-50"
                            style={{
                              borderBottomLeftRadius: `${parseInt(
                                cornerRadius,
                                10
                              )}px`,
                              borderBottomRightRadius: `${parseInt(
                                cornerRadius,
                                10
                              )}px`,
                            }}
                          >
                            {truncateNameDesktop(category.sub_category_name)}
                          </p>
                        )}
                    </div>

                    {/* Text at the Bottom */}
                    {((labelPosition === "bottom" &&
                      textAlignment === "beside") ||
                      (labelPosition === "center" &&
                        textAlignment === "beside")) && (
                      <p className="mt-2 text-sm text-black">
                        {truncateNameDesktop(category.sub_category_name)}
                      </p>
                    )}
                  </Link>
                </div>
              </div>
            ))}
          </div>
        )}
      {noOfColumn === "7" &&
        ["top", "center", "bottom"].includes(labelPosition) && (
          <div className="justify-center hidden w-full grid-cols-7 gap-1 overflow-hidden lg:grid">
            {categories.slice(0, 8).map((category) => (
              <div
                key={category.subcategory_auto_id}
                className="flex justify-center w-full"
              >
                <div
                  className="flex items-center w-full p-2 text-center"
                  style={{
                    margin: `${parseInt(itemMargin, 10)}px`,
                    padding: `${parseInt(itemPadding, 10)}px`,
                  }}
                >
                  <Link
                      to="/subsubcatproductlist"
                      state={{
                        subsubcategoryName: category.sub_category_name,
                        sub_sub_cat_id: category.sub_sub_category_auto_id,
                      }}
                    className="flex flex-col items-center w-full text-decoration-none"
                  >
                    {/* Text at the Top */}
                    {labelPosition === "top" && textAlignment === "beside" && (
                      <p className="mb-2 text-sm text-black">
                        {truncateNameDesktop(category.sub_category_name)}
                      </p>
                    )}

                    {/* Fully Rounded Image */}
                    <div className="relative w-full">
                      {textAlignment === "over" && labelPosition === "top" && (
                        <p
                          className="absolute top-0 left-0 right-0 h-10 p-2 text-sm text-center text-white bg-black bg-opacity-50"
                          style={{
                            borderTopLeftRadius: `${parseInt(
                              cornerRadius,
                              10
                            )}px`,
                            borderTopRightRadius: `${parseInt(
                              cornerRadius,
                              10
                            )}px`,
                          }}
                        >
                          {truncateNameDesktop(category.sub_category_name)}
                        </p>
                      )}
                      <img
                        src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/subcategories/${category.subcategory_image_app}`}
                        alt={category.sub_category_name}
                        className={`object-cover w-full `}
                        style={{
                          height: `${webHeight}px`,
                          borderRadius: `${parseInt(cornerRadius, 10)}px`,
                        }}
                      />
                      {/* Text Overlay for Center */}
                      {textAlignment === "over" &&
                        labelPosition === "center" && (
                          <p
                            className={`absolute inset-0 flex items-center justify-center text-sm text-white bg-black bg-opacity-50 p-2 `}
                            style={{
                              height: `${webHeight}px`,
                              borderRadius: `${parseInt(cornerRadius, 10)}px`,
                            }}
                          >
                            {truncateNameDesktop(category.sub_category_name)}
                          </p>
                        )}

                      {/* Text Overlay at the Bottom */}
                      {textAlignment === "over" &&
                        labelPosition === "bottom" && (
                          <p
                            className="absolute bottom-0 left-0 right-0 h-10 p-2 mb-0 text-sm text-center text-white bg-black bg-opacity-50"
                            style={{
                              borderBottomLeftRadius: `${parseInt(
                                cornerRadius,
                                10
                              )}px`,
                              borderBottomRightRadius: `${parseInt(
                                cornerRadius,
                                10
                              )}px`,
                            }}
                          >
                            {truncateNameDesktop(category.sub_category_name)}
                          </p>
                        )}
                    </div>

                    {/* Text at the Bottom */}
                    {((labelPosition === "bottom" &&
                      textAlignment === "beside") ||
                      (labelPosition === "center" &&
                        textAlignment === "beside")) && (
                      <p className="mt-2 text-sm text-black">
                        {truncateNameDesktop(category.sub_category_name)}
                      </p>
                    )}
                  </Link>
                </div>
              </div>
            ))}
          </div>
        )}
      {noOfColumn === "8" &&
        ["top", "center", "bottom"].includes(labelPosition) && (
          <div className="justify-center hidden w-full grid-cols-8 gap-1 overflow-hidden lg:grid">
            {categories.slice(0, 8).map((category) => (
              <div
                key={category.subcategory_auto_id}
                className="flex justify-center w-full"
              >
                <div
                  className="flex items-center w-full p-2 text-center"
                  style={{
                    margin: `${parseInt(itemMargin, 10)}px`,
                    padding: `${parseInt(itemPadding, 10)}px`,
                  }}
                >
                  <Link
                       to="/subsubcatproductlist"
                       state={{
                         subsubcategoryName: category.sub_category_name,
                         sub_sub_cat_id: category.sub_sub_category_auto_id,
                       }}
                    className="flex flex-col items-center w-full text-decoration-none"
                  >
                    {/* Text at the Top */}
                    {labelPosition === "top" && textAlignment === "beside" && (
                      <p className="mb-2 text-sm text-black">
                        {truncateNameDesktop(category.sub_category_name)}
                      </p>
                    )}

                    {/* Fully Rounded Image */}
                    <div className="relative w-full">
                      {textAlignment === "over" && labelPosition === "top" && (
                        <p
                          className="absolute top-0 left-0 right-0 h-10 p-2 text-sm text-center text-white bg-black bg-opacity-50"
                          style={{
                            borderTopLeftRadius: `${parseInt(
                              cornerRadius,
                              10
                            )}px`,
                            borderTopRightRadius: `${parseInt(
                              cornerRadius,
                              10
                            )}px`,
                          }}
                        >
                          {truncateNameDesktop(category.sub_category_name)}
                        </p>
                      )}
                      <img
                        src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/subcategories/${category.subcategory_image_app}`}
                        alt={category.sub_category_name}
                        className={`object-cover w-full `}
                        style={{
                          height: `${webHeight}px`,
                          borderRadius: `${parseInt(cornerRadius, 10)}px`,
                        }}
                      />
                      {/* Text Overlay for Center */}
                      {textAlignment === "over" &&
                        labelPosition === "center" && (
                          <p
                            className={`absolute inset-0 flex items-center justify-center text-sm text-white bg-black bg-opacity-50 p-2 `}
                            style={{
                              height: `${webHeight}px`,
                              borderRadius: `${parseInt(cornerRadius, 10)}px`,
                            }}
                          >
                            {truncateNameDesktop(category.sub_category_name)}
                          </p>
                        )}

                      {/* Text Overlay at the Bottom */}
                      {textAlignment === "over" &&
                        labelPosition === "bottom" && (
                          <p
                            className="absolute bottom-0 left-0 right-0 h-10 p-2 mb-0 text-sm text-center text-white bg-black bg-opacity-50"
                            style={{
                              borderBottomLeftRadius: `${parseInt(
                                cornerRadius,
                                10
                              )}px`,
                              borderBottomRightRadius: `${parseInt(
                                cornerRadius,
                                10
                              )}px`,
                            }}
                          >
                            {truncateNameDesktop(category.sub_category_name)}
                          </p>
                        )}
                    </div>

                    {/* Text at the Bottom */}
                    {((labelPosition === "bottom" &&
                      textAlignment === "beside") ||
                      (labelPosition === "center" &&
                        textAlignment === "beside")) && (
                      <p className="mt-2 text-sm text-black">
                        {truncateNameDesktop(category.sub_category_name)}
                      </p>
                    )}
                  </Link>
                </div>
              </div>
            ))}
          </div>
        )}
      {/* Mobile View: Rounded Carousel with 4 Items */}
      <div className="relative lg:hidden">
        <Swiper
          ref={swiperRef_sc_5}
          slidesPerView={4}
          spaceBetween={10}
          navigation={{
            nextEl: `.swiper-button-next-${data._id}`,
            prevEl: `.swiper-button-prev-${data._id}`,
          }}
          modules={[Navigation]}
          className="mySwiper"
        >
          {categories.map((category) => (
            <SwiperSlide key={category.subcategory_auto_id}>
              <div className="flex justify-center">
                <div className="flex items-center p-1 text-center">
                  <Link
                     to="/subsubcatproductlist"
                     state={{
                       subsubcategoryName: category.sub_category_name,
                       sub_sub_cat_id: category.sub_sub_category_auto_id,
                     }}
                    className="flex flex-col items-center text-decoration-none"
                  >
                    {/* Fully Rounded Image */}
                    <img
                      src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/subcategories/${category.subcategory_image_app}`}
                      alt={category.name}
                      className="object-cover rounded"
                      style={{ height: "140px", width: "80px" }}
                    />
                    <p className="mt-2 text-sm text-black">
                      {truncateNameMobile(category.sub_category_name)}
                    </p>
                  </Link>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        {/* 
                Custom Navigation Arrows */}
        <div className={`swiper-button-next-${data._id}`}></div>
        <div className={`swiper-button-prev-${data._id}`}></div>
      </div>
    </div>
  );
};

export default SubSubCategory5;
